<template>
  <!-- fqa section -->
  <section class="fqa py-5">
    <!-- shadow image -->
    <img
      src="@/assets/images/shadow-bg.png"
      alt="shadow bg"
      class="shadow-bg"
    />
    <!-- shadow image -->
    <div class="container py-5">
      <h2
        class="fqa__heading page-heading text-center"
        data-aos="fade-up"
        data-aos-offset="0"
      >
        Frequently Asked Questions
      </h2>
      <div class="row">
        <div class="col-lg-5 col-xl-4">
          <div class="fqa__intro pe-lg-5">
            <h3 class="fqa__intro__title mb-4" data-aos="fade-right">
              Do you have any quesiton?
              <br />Please ask here we ready to support
            </h3>
            <p
              class="fqa__intro__desc mb-4 pb-3"
              data-aos="fade-right"
              data-aos-delay="100"
            >
              If your question is not list here, <br />please feel free to make
              a manual support.
            </p>
            <button
              class="fqa__intro__btn button button--full-border"
              data-aos="fade-right"
              data-aos-delay="200"
            >
              <span>Ask your Question</span>
            </button>
          </div>
        </div>
        <div class="col-lg-7 col-xl-8">
          <div>
            <ul class="fqa__list" data-aos="fade-up">
              <li
                class="fqa__list__item expanded"
                v-for="question in fqaList"
                :key="question.id"
              >
                <div
                  class="fqa__list__item__header d-flex align-items-center justify-content-between"
                  ref="fqa__list__item__header"
                  @click="expandCard"
                >
                  {{ question.question }}
                </div>
                <div
                  class="fqa__list__item__body"
                  v-html="question.answer"
                ></div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- end fqa section -->
</template>

<script>
export default {
  name: "fqu",
  data() {
    return {
      fqaList: [
        {
          id: 1,
          question: "How much does it cost to bea 365 member?",
          answer:
            "<p>For our recent trip to S.A. I booked several accommodation thru SA Places. I just wanted to tell you that everything worked out perfectly with all the bookings and also your booking was very quick and professional. I hope I have the opportunity to re-visit South Africa soon, I will then make my bookings with your company again. I will also recommend</p>",
        },
        {
          id: 2,
          question: "How can I join as a influincer?",
          answer:
            "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.</p>",
        },
        {
          id: 3,
          question: "What is the prizes for the daily playing?",
          answer:
            "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.</p>",
        },
        {
          id: 4,
          question: "Can I make cash payments?",
          answer:
            "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.</p>",
        },
        {
          id: 5,
          question: "How do I get the payment complete?",
          answer:
            "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.</p>",
        },
      ],
    };
  },
  methods: {
    expandCard(e) {
      if (e.currentTarget.classList.contains("expanded")) {
        e.currentTarget.classList.remove("expanded");
        e.currentTarget.nextElementSibling.style.maxHeight = "0";
      } else {
        this.$refs["fqa__list__item__header"].forEach((item) => {
          item.classList.remove("expanded");
          item.nextElementSibling.style.maxHeight = "0";
        });
        e.currentTarget.classList.add("expanded");
        e.currentTarget.nextElementSibling.style.maxHeight =
          e.currentTarget.nextElementSibling.scrollHeight + "px";
      }
    },
  },
};
</script>
